<template>
	<section>
		<header-page
			name="users-apps"
			:title="$route.meta.title"
		/>
		<general-filter class="mt-3">
			<v-layout row wrap align-center justify-start>
				<v-flex xs3 pr-3>
					<v-select
						background-color="white"
						box
						class="body-1"
						hide-details
						item-text="name"
						item-value="codeApp"
						:items="apps"
						label="Aplicaciones"
						v-model="codeApp"
					>
					</v-select>
				</v-flex>
				<v-flex xs3 pr-3>
					<v-select
						background-color="white"
						box
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						:items="roles"
						label="Roles"
						v-model="roleId"
					>
					</v-select>
				</v-flex>
				<v-flex xs2>
					<v-btn
						color="green"
						class="btn-action caption"
						@click="addApps"
					>
						<v-icon>add</v-icon>
						Agregar
					</v-btn>
				</v-flex>
			</v-layout>
		</general-filter>
		<app-user-list
			:columns="columns"
			:rows="table.rows"
			@delete-role="deleteRole"
		/>
	</section>
</template>

<script>
	import appUserList from '@/components/apps/app-user-list';

	function created() {
		const version = 1;
		this.loadResources();
		this.params.codeCompany = this.$route.params.idCompany;
		this.loadData(`project/${this.codeProject}/user/${this.codeUser}/permission`, version);
	}

	async function addApps() {
		const codeApp = this.codeApp;
		const roleId = this.roleId;
		const codeCompany = this.$route.params.idCompany;
		const version = 1;
		try {
			await this.$http.post(`permission/${this.codeUser}`, { codeApp, roleId, codeCompany });
			this.showNotification('La aplicación se asignó correctamente.', 'success');
			this.codeApp = '';
			this.roleId = 0;
			this.loadData(`project/${this.codeProject}/user/${this.codeUser}/permission`, version, codeCompany);
		} catch (err) {
			if (err.status === 405) {
				if (err.data.message === 'El usuario tiene rol asignado para la aplicación.') {
					this.showNotification('El usuario ya tiene un rol asignado para la aplicación seleccionada.', 'error');
				}
			} else {
				this.showError();
			}
		}
	}

	async function loadResources() {
		const request = [
			this.$http.get(`project/${this.codeProject}/apps`),
			this.$http.get(`company/${this.idCompany}/project/${this.codeProject}/role`),
		];
		const [apps, roles] = await Promise.all(request);
		this.apps = apps.data.data;
		this.roles = roles.data.data;
	}

	function deleteRole(value) {
		const version = 1;
		const codeCompany = this.$route.params.idCompany;
		this.$http
			.delete(`permission/${value}`)
			.then(() => {
				this.showNotification('Registro eliminado correctamente');
				this.modalConfirmation.value = false;
				this.loadResources();
				this.loadData(`project/${this.codeProject}/user/${this.codeUser}/permission`, version, codeCompany);
			});
	}

	function data() {
		return {
			apps: [],
			codeApp: '',
			columns: [
				{ id: 1, name: 'Aplicación', checked: true, visible: true },
				{ id: 2, name: 'Rol', checked: true, visible: true },
				{ id: 3, name: 'Acciones', checked: true, visible: true },
			],
			roleId: 0,
			roles: [],
		};
	}

	export default {
		name: 'page-app-user',
		components: {
			appUserList,
		},
		created,
		data,
		methods: {
			addApps,
			loadResources,
			deleteRole,
		},
		props: {
			codeProject: {
				type: String,
			},
			codeUser: {
				type: String,
			},
			idCompany: {
				type: String,
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/pages/users/page-app-user.vue